import React from 'react';
import { Row, Col } from 'antd';
import './FormStyles.css';

// Ported from promedhis: lays out Form.Item children in a responsive grid,
// giving long-text fields the full row and everything else a third-width column.
const FULL_WIDTH_FIELDS = [
  'Notes', 'Comments', 'Description', 'Address', 'StreetAddress', 'Method',
  'Interpretation', 'History', 'CalculationFormula', 'TemplateContent',
];

// Fields that need more room than a third-width column (e.g. an input + inline
// "Generate New" button) but don't warrant the full row.
const HALF_WIDTH_FIELDS = ['CohortName'];

const ResponsiveFormLayout = ({ children, fieldsConfig = {} }) => {
  const getColSpan = (fieldName, fieldProps) => {
    if (FULL_WIDTH_FIELDS.includes(fieldName) || fieldProps?.type === 'List`1' || fieldProps?.type === 'TemplateContent') {
      return { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 };
    }
    if (HALF_WIDTH_FIELDS.includes(fieldName)) {
      return { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 };
    }
    return { xs: 24, sm: 12, md: 8, lg: 8, xl: 8 };
  };

  const items = Array.isArray(children) ? children : [children];

  return (
    <div className="responsive-form-container">
      <Row gutter={[12, 4]} style={{ width: '100%' }} align="top">
        {items.filter(Boolean).map((child, index) => {
          const fieldName = child.key?.replace(/^form-item-([^-]+).*$/, '$1') || '';
          const span = getColSpan(fieldName, fieldsConfig[fieldName]);
          return (
            <Col key={child.key || `col-${index}`} {...span} style={{ marginBottom: 4 }}>
              <div className="responsive-form-field">{child}</div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default ResponsiveFormLayout;
